import React, { Component } from 'react';
import { Box, Card, CardContent, Typography, Skeleton, Grid } from '@mui/material';
import { withRouter } from '../../services/security/withRouter';
import ContentService from '../../services/ContentService';

class ContentGeneratedImages extends Component {
    state = {
        images: [],
        loading: true,
        error: null,
    };

    async componentDidMount() {
        const { contentId } = this.props;
        try {
            const images = await ContentService.getImages(contentId);
            this.setState({ images, loading: false });
        } catch (error) {
            this.setState({ error: error.message, loading: false });
        }
    }

    handleCardClick = (imageId) => {
        const { contentId } = this.props;
        this.props.navigate(`/image?id=${imageId}&contentId=${contentId}`);
    };

    render() {
        const { images, loading, error } = this.state;

        if (loading) {
            return (
                <Grid container spacing={2}>
                    {[1, 2, 3].map((_, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card>
                                <CardContent>
                                    <Skeleton variant="rectangular" width="100%" height={118} />
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            );
        }

        if (error) {
            return <Typography color="error">{error}</Typography>;
        }

        if (images.length === 0) {
            return <Typography variant="body1" color="textSecondary" sx={{ padding: 4 }}>No images generated yet.</Typography>;
        }

        return (
            <Box sx={{ padding: 4 }}>
                <Grid container spacing={2}>
                    {images.map((entry) => (
                        <Grid item xs={12} sm={6} md={4} key={entry.id}>
                            <Card onClick={() => this.handleCardClick(entry.id)} sx={{ cursor: 'pointer' }}>
                                <CardContent>
                                    <Typography variant="body1" sx={{ padding: 4 }}>{entry.prompt}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }
}

export default withRouter(ContentGeneratedImages);